module.exports = __webpack_public_path__ + "img/q3.68610809.gif";